import { useLayoutEffect, useRef, useState } from 'react';
import StretchyParentheses from './StretchyParentheses';
import { renderLatexAST } from './renderLatex';
import type { LatexNode } from '../types';

function ResizableParentheses({ content }: { content: LatexNode }) {
    const contentRef = useRef<HTMLSpanElement>(null);
    const [height, setHeight] = useState(40); // default fallback height

    useLayoutEffect(() => {
        if (contentRef.current) {
            const h = contentRef.current.offsetHeight;
            setHeight(Math.max(h, 20)); // clamp minimum height
        }
    }, []);

    return (
        <span
            className="latex-resizable-paren-group"
            style={{ display: 'inline-flex', alignItems: 'flex-start' }}
        >
            <StretchyParentheses height={height} side="left" />
            <span ref={contentRef}>{renderLatexAST(content)}</span>
            <StretchyParentheses height={height} side="right" />
        </span>
    );
}

export default ResizableParentheses;
